import React, { useRef, useState } from 'react';
import ListPageLayout from '../../ListPageLayout/ListPageLayout';
import { Filter, IFilterProps, IFilterRef } from '../../Filter/Filter';
import { AuditionGrid, IAuditionGrid } from '../../AuditionComponents/AuditionGrid';
import { IAudition } from '../../../types/global/helper';

export interface IAuditionListContainer extends IFilterProps, IAuditionGrid {
    auditions: IAudition[];
    loading?: boolean;
    onCenterEndReached?: () => void;
    onRightEndReached?: () => void;
}
export const AuditionListContainer: React.FC<IAuditionListContainer> = ({ auditions, loading, ...props }) => {
    const filterRef = useRef<IFilterRef>(null);
    const [openInMobile, setOpenInMobile] = useState(false);
    /** This updates the filter with the current value when it is removed */
    const synschoniseFilter = (filter: any) => {
        filterRef.current?.onUpdateFilter(filter);
    };
    return (
        <ListPageLayout
            RightComponent={<Filter ref={filterRef} onClose={() => setOpenInMobile(false)} {...props} />}
            TopComponent={
                <AuditionGrid
                    auditions={auditions}
                    onUpdateFilter={synschoniseFilter}
                    toggleFilterInMobile={() => setOpenInMobile(true)}
                    {...props}
                />
            }
            BottomLeftComponent={<div></div>}
            BottomRightComponent={<div></div>}
            centerContentLoading={loading}
            enableRightMobile
            onCloseRightMobile={() => setOpenInMobile(false)}
            openRightInMobile={openInMobile}
            {...props}
        />
    );
};
